














import {Component, Prop, Vue, Watch} from 'vue-property-decorator';
import List from '@/views/document/section/List.vue';
import dokument from '@/store/modules/dokument';
import {Item, ListSection} from '@/store/models';

@Component({components: {List}})
export default class CompetitorAnalysis extends Vue {
  @Prop() readonly group!: any;

  init() {
    this.text = '';
  }

  get text() {
    return dokument.Texts[`analysis_summary`];
  }

  set text(value: string) {
    dokument.setText({Type: 'analysis_summary', Text: value});
  }

  get section(): any {
    return dokument.getItem(701) as Item;
  }

  get texts() {
    return dokument.Texts;
  }

  @Watch('texts', {immediate: true, deep: true})
  onData() {
    if (this.section.Hidden !== this.hidden) {
      const s = {
        Id: this.section.Id,
        Kind: this.section.Kind,
        Type: this.section.Type,
        SubType: this.section.SubType,
        Hidden: this.hidden,
        PrintOnly: this.section.PrintOnly,
      };
      dokument.updateItem(s);
    }
  }

  get hidden(): boolean {
    if (this.text) {
      return false;
    }
    return true;
  }
}
